import axios from "axios";
import store from "@/store"
// import router from "@/router";

export async function backendPostRequest(endPoint, payload) {
	const apiUrl = store.getters["common/getBackendApiUrl"]
	const proxy = store.getters["common/getProxy"]
	const url = proxy + apiUrl + endPoint
	const api = axios.create()

	let errCount = 0

	console.log('url',url)
	console.log('payload',payload)

	api.interceptors.request.use(config=>{
		//console.log('request config',config)
		const accessToken = window.keycloak.token
		// const accessToken = store.getters["common/getUser"].accessToken
		if (accessToken!==""){ config.headers.Authorization = "Bearer "+accessToken }
		return config
	}, error => {
		console.log('request error',error)
	})

	api.interceptors.response.use(config=>{
		//console.log('response config',config)
		// const accessToken = store.getters["common/getUser"].accessToken
		const accessToken = window.keycloak.token
		if (accessToken!==""){ config.headers.Authorization = "Bearer "+accessToken }
		return config
	}, async error => {
		errCount = errCount + 1
		console.log('api request error')
		console.log(error.response.data)
		if (errCount>2){ return error.response }

		// if (error.response.status === 401 && error.response.data.message==="jwt expired") {
		if (error.response.status === 401) {
			await window.keycloak.updateToken()
				error.config.headers.Authorization = "Bearer " + window.keycloak.token
				return api.request(error.config)

			// const refreshToken = store.getters["common/getUser"].refreshToken
			// 	const refresh = await axios.post(`${proxy}${apiUrl}auth/refresh`, {refreshToken}, {
			// 		headers: {"Content-Type": "application/json"},
			// 	})

				// if (refresh.status === 200 && refresh.data.status === "ok") {
				// 	store.commit("common/setUser", {
				// 		email: refresh.data.email,
				// 		accessToken: refresh.data.accessToken,
				// 		refreshToken: refresh.data.refreshToken,
				// 	})
				// 	const accessToken = store.getters["common/getUser"].accessToken
				// 	error.config.headers.Authorization = "Bearer " + accessToken
				// 	return api.request(error.config)
				// }else if (refresh.status === 401 && refresh.data.message==="jwt expired"){
				// 	//TODO сделать проверку на то не истек ли refresh token
				// 	await router.push({name: "LoginPage"})
				// 	return error.response.data
				// }else {
				// 	return error.response.data
				// }
		} else {
			return error.response
		}

	})

	try {
		const result = await api.post(url, JSON.stringify(payload), {
			headers: {"Content-Type": "application/json"},
		})
		//console.log('---------------------')
		//console.log(result)
		return result.data
	}catch (e) {
		console.log('catch api',e)
		return {status:"fail",message: e.message}
	}
}